import { InternalAxiosRequestConfig } from "axios";

export enum APITypes {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
};

export type APIRouteType = {
  url: string;
  method: APITypes;
  isBodyRequired: boolean;
  isQueryParamsRequired: boolean;
  isPathParamsRequired: boolean;
  isAuthHeaderRequired: boolean;
  isFileUpload: boolean;
};

export enum APIEndpoints {
  USER_SIGNIN = 'signIn',
  USER_FORGOT_PASSWORD = 'forgotPassword',
  USER_LOGOUT = 'logout',
  USER_RESET_PASSWORD = 'resetPassword',
  CASE_LIST = "caseList",
  GET_PROVIDER_SPECIALITIES = 'getProviderSpecialities',
  USER_UPDATE = 'userUpdate',
  ADD_USER = 'addUser',
  NPI_LOOKUP = 'npiLookup',
  ADD_PROVIDER = 'addProvider',
  PRACTICE_DROPDOWN = 'practiceDropdown',
  PATIENT_DROPDOWN = 'patientDropdown',
  PROVIDER_DROPDOWN = 'providerDropdown',
  ADD_ENROLLMENT = 'addEnrollment',
  GET_PROCEDURE_DROPDOWN = 'getProcedureDropdown',
  GET_DIAGNOSIS_DROPDOWN = 'getDiagnosisDropdown',
  GET_SITE_OF_CARE_DROPDOWN = 'getSiteOfCareDropdown',
  ADD_NEW_CASE = 'addNewCase',
  GET_PATIENT_DETAILS_BY_ID = 'getPatientDetailsById',
  CASE_DETAIL  = 'caseDetail',
  ADD_NOTE = "addNote",
  FETCH_DOCUMENT = 'fetchDocument',
  UPLOAD_CASE_FILE = "uploadCaseFile",
  DOWNLOAD_ZIP_FILE = 'downloadZipFile',
  CLONE_CASE_DETAILS = 'cloneCaseDetails',
  TREATMENT_LISTING = 'treatmentListing',
  ORDER_LISTING = 'orderListing',
  CREATE_ORDER = 'createOrder',
  TREATMENT_STATUS_UPDATE  = 'treatmentStatusUpdate',
  SCHEDULE_REP_VISIT = 'scheduleRepVisit',
  UPLOAD_PEF = 'uploadPEF',
  REQUEST_TREATMENT_NOT_TREATING = 'requestTreatmentNotTreating',
  DOWNLOAD_REQUEST_FORM = 'downloadRequestForm',
  PATIENT_STATISTICS  = 'patientStatistics',
  PATIENT_DASHBOARD = 'patientDashboard',
  PRACTICE_DOCTOR_DROPDOWN = 'practiceDoctorDropDownStatistics',
  ACTION_DASHBOARD_DATA = 'actionDashboardData',
  TODO_ACTION_DASHBOARD_STATISTICS='todoActionDashboardStatistic',
  PRACTICE_DOCTOR_DROPDOWN_STATISTICS='practiceDoctorDropDownStatistics',
  USER_LIST_STATISTICS='userListStatistics',
  SAVE_NOTE='saveNote',
  MANUFACTURE_STATISTICS  = 'manufactureStatistics',
  MANUFACTURE_STATISTICS_SOC_DOCTOR_DROPDOWN  ='manufactureStatisticsSocAndDoctorsDropdown',
  MANUFACTURE_STATISTICS_REPORT_DOWNLOAD = 'manufactureStatisticsReportDownload',
  DEMO_RESET_CASES = 'demoResetCases',
  GET_GLOBAL_PATIENT_DETAIL_BY_ID = 'getGlobalPatientDetailsById',
  UPDATE_GLOBAL_PATIENT_DETAIL_BY_ID = 'updateGlobalPatientDetailsById',
  SUBMIT_PRECERT = 'submiPrecert',
  APPEAL_CASE = 'appealCase',
  REVIEW_PRECERT_APPROVE = 'reviewPrecertApprove',
  REVIEW_PRECERT_DENY = 'reviewPrecertDeny',
  TRANSFER_CASE = 'transferCase',
  TRANSFER_RX = 'transferRX',
  CASE_DETAIL_POPUP = 'caseDetailPopup',
  FETCH_PRECERT='fetchPrecert',
  EOBs_DETAIL  = 'eobsDetail',
  EOBs_LISTING = 'eobsListing',
  EOBs_Upload = 'eobsUpload',
  FETCH_EOB_FILE = 'fetchEOBsFile',
  GET_PRODUCTS = 'getProducts',
  EOB_FILTER_LISTING = 'eobsFilterListing',
  MARK_CEP = 'markCEP',
  AD_PROVIDER_DROPDOWN = 'ADProviderDropdown',
  FETCH_CASE_INSURANCES = 'fetchCaseInsurances',
  ADD_QN_SPECIALIST = 'addQNSpecialist',
  ACTIONDASHBOARD_SECTION_ORDER='actionDashboardSectionOrder',
  INSURANCE_DROPDOWN = 'InsuranceDropdown',
  PLAN_DROPDOWN = 'PlanDropdown',
};

export type AuthAPIsType = {
  [key in APIEndpoints]: APIRouteType;
};

export type FetchHookType<TPathParams, TQueryParams, TResponseData> =
  (apiType: APIEndpoints, pathParams?: TPathParams, queryParams?: TQueryParams) =>
    { loading: boolean, error: string | null, data: TResponseData, mutate: <TBodyType>(body: TBodyType) => void };

export type UpdatedAxiosInstance<T> = InternalAxiosRequestConfig<T> & {
  pathParams: object;
};
